import { vectorM } from '../navChevrons.ts';
import type { Coordinate } from '../types.ts';

/** The [lng, lat] point halfway along the length of a polyline (meters-based). Two points give their center. */
export function pointAtHalfLength(coordinates: Coordinate[]): Coordinate {
  const lengths = coordinates.slice(1).map((end, index) => {
    const [dx, dy] = vectorM(coordinates[index], end);
    return Math.hypot(dx, dy);
  });
  const half = lengths.reduce((sum, length) => sum + length, 0) / 2;
  if (half === 0) {
    return coordinates[0];
  }
  let travelled = 0;
  for (const [index, length] of lengths.entries()) {
    if (travelled + length >= half) {
      const t = length === 0 ? 0 : (half - travelled) / length;
      const [lng1, lat1] = coordinates[index];
      const [lng2, lat2] = coordinates[index + 1];
      return [lng1 + (lng2 - lng1) * t, lat1 + (lat2 - lat1) * t];
    }
    travelled += length;
  }
  return coordinates.at(-1)!;
}
